import { loginMember } from './login-member';
import requestLogin from '../services/request-login';

export default function requestLoginAction() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      requestLogin(response => {
        if (response) {
          dispatch(loginMember(response)); // Needed because in some cases requestLogin does not reload an iframe
          resolve();
        } else {
          reject();
        }
      });
    });
  };
}



// WEBPACK FOOTER //
// ./app/actions/request-login.js